import React, { useState, Suspense, useContext, useEffect } from "react";
import {
  DashboardOutlined,
  UserOutlined,
  TeamOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Row,
  Col,
  Select,
  Space,
  Dropdown,
  Avatar,
  Tooltip,
} from "antd";
import logo1 from "../logo.png";
import patientimg from "../patient.jpg";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import GlobalSpinner from "../features/CommonComponents/GlobalSpinner/GlobalSpinner";
import routes from "./routes";
import { Context } from "../components/Wrapper";
import { FormattedMessage } from "react-intl";
const { Header, Content, Footer, Sider } = Layout;
function ProtectedRoutes() {
  const location = useLocation();
  const context = useContext(Context);
  const [collapsed, setCollapsed] = useState(false);
  const userFirstName = localStorage.getItem("userFirstName");
  const userLastName = localStorage.getItem("userLastName");
  const userRoles = localStorage.getItem("roles");
  const handleLogOut = () => {
    const lastVisitedRoute = localStorage.getItem("lastVisitedRoute");
    const selectedLanguage = localStorage.getItem("selectedlanguage");
    localStorage.clear();
    if (lastVisitedRoute) {
      localStorage.setItem("lastVisitedRoute", lastVisitedRoute);
    }
    if (selectedLanguage) {
      localStorage.setItem("selectedlanguage", selectedLanguage);
    }
    window.location.reload(true);
  };
  const items = [
    // {
    //   label: (
    //     <a href="">
    //       <FormattedMessage id="Common.MyProfile" />
    //     </a>
    //   ),
    //   key: "0",
    // },
    // {
    //   label: (
    //     <a href="">
    //       <FormattedMessage id="Common.Settings" />
    //     </a>
    //   ),
    //   key: "1",
    // },

    {
      label: (
        <a onClick={() => handleLogOut()}>
          <FormattedMessage id="Common.Logout" />
        </a>
      ),
      key: "3",
    },
  ];

  const handleKey = () => {
    const locName = location.pathname;
    if (locName?.includes("patients")) {
      return "2";
    } else if (locName?.includes("clients")) {
      return "3";
    } else {
      return "1";
    }
  };
  useEffect(() => {
    if (location.pathname != "/login") {
      localStorage.setItem("lastVisitedRoute", location.pathname);
    }
  }, [location]);
  return (
    <>
      <Layout>
        <Header
          style={{
            width: "100%",
            padding: "16px 18px",
            background: "#fff",
            borderBottom: "solid 1px #e5e5e0",
            display: "flex",
            justifyContent: "space-between", // align items to end
            alignItems: "center", // vertical center
            height: " 72px",
          }}
        >
          <div className="demo-logo-vertical text-center">
            <Space>
              <img src={logo1} style={{ height: "50px" }} alt="" />
              <h2 className="f-20px">
                <span style={{ color: "#336899" }}>CORPUS VITALS</span> -{" "}
                <FormattedMessage id="Common.MonitorHealthMetrics" />
              </h2>
            </Space>
          </div>
          <div className="header-part">
            <Space size={16}>
              <Select
                value={context.locale}
                onChange={context.selectLang}
                variant="borderless"
                defaultValue="en"
                options={[
                  {
                    value: "en-US",
                    label: "English",
                  },
                  {
                    value: "fr-FR",
                    label: "French",
                  },
                ]}
              />
              <Tooltip title={<FormattedMessage id="Common.Logout" />}>
                <LoginOutlined onClick={() => handleLogOut()} />
              </Tooltip>
              <Space className="herader-profile">
                <div className="text-right">
                  <p>{`${userFirstName} ${userLastName}`}</p>
                  <span className="role">
                    {(userRoles || "").split(",")[0].trim()}
                  </span>
                </div>
                <Avatar
                  style={{
                    backgroundColor: "#336899",
                    color: "#fff",
                    textTransform: "uppercase",
                  }}
                  size="large"
                >
                  <UserOutlined />
                </Avatar>
              </Space>
            </Space>
          </div>
        </Header>

        <Layout>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            width={230}
            onBreakpoint={(broken) => {
              console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              console.log(collapsed, type);
            }}
          >
            <h2 class="text-overview">
              <FormattedMessage id="Common.Overview" />
            </h2>
            <Menu
              theme="light"
              mode="inline"
              // defaultSelectedKeys={["1"]}
              defaultSelectedKeys={[handleKey()]}
            >
              <Menu.Item key="1" icon={<DashboardOutlined />}>
                <Link to="/chyroDashboard">
                  <span>
                    <FormattedMessage id="Common.Dashboard" />
                  </span>
                </Link>
              </Menu.Item>
              <Menu.Item key="2" icon={<TeamOutlined />}>
                <Link to="/patients">
                  <span>
                    <FormattedMessage id="Common.Patients" />
                  </span>
                </Link>
              </Menu.Item>
              {userRoles.includes("Admin") && (
                <Menu.Item key="3" icon={<UserOutlined />}>
                  <Link to="/clients">
                    <span>
                      <FormattedMessage id="Common.Admin" />
                    </span>
                  </Link>
                </Menu.Item>
              )}
            </Menu>
          </Sider>

          <Content>
            <div
              style={{
                padding: "18px 24px",
                minHeight: 360,
                background: "#f8fafc",
                position: "relative",
              }}
            >
              <div className="main-div-block">
                {/* <Dashboard /> */}
                <Routes>
                  {routes.map(
                    ({ component: Component, path, exact }, index) => (
                      <Route
                        path={`/${path}`}
                        key={index}
                        exact={exact}
                        element={
                          <Suspense
                            fallback={
                              <div>
                                <span>
                                  <FormattedMessage id="Common.Loading" />
                                </span>
                              </div>
                            }
                          >
                            <Component />
                          </Suspense>
                        }
                      >
                        {/* <GlobalSpinner
                          appContainer={<Component />}
                        ></GlobalSpinner> */}
                        {/* <div className={`fg ${isActiveMenu ? "shown" : ""}`}>
                          <SideMenu />
                        </div> */}
                      </Route>
                    )
                  )}
                </Routes>
              </div>
            </div>
          </Content>
        </Layout>
        <Footer
          style={{
            textAlign: "center",
          }}
        >
          <FormattedMessage id="Common.Copyright" /> ©{" "}
          {new Date().getFullYear()}{" "}
          <FormattedMessage id="Common.AllRightsReserved" />
        </Footer>
      </Layout>
    </>
  );
}

export default ProtectedRoutes;
